import createItemFetcher from "../helpers/item";
import { createUseItem } from "../helpers/fetchHooks";
import { createActionDuck } from "../helpers/action";
import { createUseAction } from "../helpers/actionHooks";
import { createNotificationsEpic } from "../helpers/notifications";
const computeJobsId = () => "focasJobs";
const computeFocasJobsUrl = () => "/api/v1/aggregation-service/jobs";
const getFocasJobs = createItemFetcher(computeFocasJobsUrl, "FOCAS_JOBS_GET", computeJobsId);
export const useFetchFocasJobs = createUseItem(getFocasJobs, (state) => state.focasJobs.jobs);
const computeCreateFocasJobUrl = () => ({
    url: "/api/v1/aggregation-service/jobs",
    method: "POST",
});
const focasJobsCreateDuck = createActionDuck("FOCAS_JOB_CREATE", computeCreateFocasJobUrl, computeJobsId);
focasJobsCreateDuck.middleware = focasJobsCreateDuck.middleware.concat(createNotificationsEpic(focasJobsCreateDuck.ActionKeys, "Job created", () => ""));
export const useCreateFocasJobs = createUseAction(focasJobsCreateDuck, (state) => state.focasJobs.create);
const computeUpdateFocasJobUrl = (jobName) => ({
    url: `/api/v1/aggregation-service/jobs/${jobName}`,
    method: "PUT",
});
const focasJobsUpdateDuck = createActionDuck("FOCAS_JOB_UPDATE", computeUpdateFocasJobUrl, computeJobsId);
focasJobsUpdateDuck.middleware = focasJobsUpdateDuck.middleware.concat(createNotificationsEpic(focasJobsUpdateDuck.ActionKeys, "Job updated", () => ""));
export const useUpdateFocasJobs = createUseAction(focasJobsUpdateDuck, (state) => state.focasJobs.update);
const compuetDeleteFocasJobUrl = (jobName) => ({
    url: `/api/v1/aggregation-service/jobs/${jobName}`,
    method: "DELETE",
});
const focasJobDeleteDuck = createActionDuck("FOCAS_JOB_DELETE", compuetDeleteFocasJobUrl, computeJobsId);
focasJobDeleteDuck.middleware = focasJobDeleteDuck.middleware.concat(createNotificationsEpic(focasJobDeleteDuck.ActionKeys, "Job deleted", () => ""));
export const useDeleteFocasJobs = createUseAction(focasJobDeleteDuck, (state) => state.focasJobs.delete);
export function createFocasJobsActions() {
    const computeGetFocasJobUrl = (jobName) => `/api/v1/aggregation-service/jobs/${jobName}`;
    const getFocasJob = createItemFetcher(computeGetFocasJobUrl, "FOCAS_JOB_GET", computeJobsId);
    return {
        create: focasJobsCreateDuck,
        update: focasJobsUpdateDuck,
        delete: focasJobDeleteDuck,
        jobs: getFocasJobs,
        job: getFocasJob,
    };
}
//# sourceMappingURL=focasJobsActions.js.map